// Decode a JWT payload for display/UX only — never for authorisation (the
// signature is not checked here; the backend is the enforcement point).
//
// JWT segments are base64url (RFC 7515): '-' and '_' instead of '+' and '/', and no
// '=' padding. Plain atob() throws on those, and it yields Latin-1 bytes, so names
// with non-ASCII characters came out garbled. Decode the bytes as UTF-8.
export const decodeBase64Url = (segment) => {
    const base64 = String(segment).replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const binary = atob(padded);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    return new TextDecoder('utf-8').decode(bytes);
};

/** @returns {object|null} the payload object, or null when the token is missing or malformed */
export const decodeJwtPayload = (token) => {
    if (!token || typeof token !== 'string') return null;
    const part = token.split('.')[1];
    if (!part) return null;
    try {
        const payload = JSON.parse(decodeBase64Url(part));
        return payload && typeof payload === 'object' ? payload : null;
    } catch {
        return null;
    }
};
